export const MAP_SETTINGS_KEY = 'hiiker_map_settings';

export type MapProjection = 'mercator' | 'globe';

export interface MapSettings {
  lockToNorth: boolean;
  projection: MapProjection;
  elevationExaggeration: number;
}

export const DEFAULT_MAP_SETTINGS: MapSettings = {
  lockToNorth: false,
  projection: 'globe',
  elevationExaggeration: 1.0,
};

export function getMapSettings(): MapSettings {
  try {
    const raw = localStorage.getItem(MAP_SETTINGS_KEY);
    if (raw) return { ...DEFAULT_MAP_SETTINGS, ...JSON.parse(raw) };
  } catch {}
  return { ...DEFAULT_MAP_SETTINGS };
}

export function saveMapSettings(settings: MapSettings): void {
  try {
    localStorage.setItem(MAP_SETTINGS_KEY, JSON.stringify(settings));
  } catch {}
}

export function applyMapSettings(map: any, settings: MapSettings): void {
  // Lock to north
  if (settings.lockToNorth) {
    map.setBearing?.(0);
    map.dragRotate?.disable();
    map.touchZoomRotate?.disableRotation();
  } else {
    map.dragRotate?.enable();
    map.touchZoomRotate?.enableRotation();
  }

  // Projection
  try { map.setProjection(settings.projection); } catch {}

  // Elevation exaggeration (only when terrain is active)
  try {
    if (map.getTerrain()) {
      map.setTerrain({ source: 'mapbox-dem', exaggeration: settings.elevationExaggeration });
    }
  } catch {}
}
